import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import InterfaceCompatibility from "../../../components/Interface/InterfaceCompatibility";

class Component_record_eval extends PureComponent {
  render() {
    return (
      <div className="row" id="component_record_eval">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Component EVAL</h2>
              <p>
                EVAL is a method of inserting simple JavaScript into the
                interface. It can hide components based on values inside the
                record or it could be used as an action an event like
                “on_click_eval”, “on_change_eval” or “hide_if_eval”. Different
                components support different EVAL so check the component
                documentation.
              </p>
              <p>
                Custom EVAL code has access to two objects. The “event” object
                will give you till you what triggered the event, old vs new
                values etc. and the “NL” object.
              </p>
              <p>
                The “NL” object is the backbone of the Nexoid Application. NL
                stands for Nexoid Library and is how you create, update, read,
                delete, search records. It also has access to other API
                functions like creating user notifications, sending emails or
                text messages etc.
              </p>
              <p>
                For more information, refer to the NL overview in the workflow
                section of this documentation.
              </p>
              <InterfaceCompatibility
                dashboard={true}
                record={true}
                report={true}
                search={true}
              />
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>EVAL Example</h2>
            </section>
            <section>
              <h3>Example 1: Simple EVAL hide</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"hide_if_eval"</span>:{" "}
                  <span className="jsonY">
                    "(NL.Record.data.text_name === 'abc')"
                  </span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
            <section>
              <h3>Example 2: Show the NL library in the browser console</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"on_click_eval"</span>:{" "}
                  <span className="jsonY">"console.log('NL object', NL);"</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
            <section>
              <h3>Example 3: Show the event object in the browser console</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"on_change_eval"</span>:{" "}
                  <span className="jsonY">
                    "console.log('event object', event);"
                  </span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Component_record_eval;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Component_record_eval.js